import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogueBase from '../../../components/dialogues/DialogueBase';
import Button from '../../../components/Button';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '50rem',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  content: {
  },
  list: {
    width: '100%',
    padding: '1rem',
  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    padding: '2rem 0 1rem 0',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'center',
      width: '100%',
    },
  },
  button: {
    marginRight: '1rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '1rem',
    },
  },
  icon: {
    fontSize: '5rem',
    marginRight: '1.5rem',
    marginBottom: '1rem',
  },
  progress: {
    width: '10rem',
    height: '0.8rem',
  },
}));

const DeleteGroupDialogue = ({open, onClose, checked, setChecked, deleteFile}) => {
  const classes = useStyles();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const deleteGroup = async () => {
    setBusy(true);
    checked.map(d => deleteFile(d.uuid));
    setChecked([]);
    setDone(true);
    setBusy(false);
  };

  useEffect(() => {
    setDone(false);
  }, [open]); // eslint-disable-line

  return (
    <DialogueBase open={open} onClose={onClose} title="Delete checked items">
      <div className={classes.root}>
        {done ? (
          <Fragment>
            <CheckCircleOutlineIcon color="secondary" className={classes.icon} />
            <Typography variant="h3">The selected files have been deleted.</Typography>
          </Fragment>
        ) : (
          <Fragment>
            <Typography variant="h3">You have selected the following files to be deleted:</Typography>
            <ul className={classes.list}>
              {checked.map(f => <li key={f.uuid}>{f.name}</li>)}
            </ul>
            {busy ? (
              <LinearProgress
                color="secondary"
                className={classes.progress}
              />
            ) : (
              <Typography variant="h3">To continue, click the <b>Confirm</b> button.</Typography>
            )}
          </Fragment>
        )}
        <div className={classes.buttons}>
          {done && !busy ? (
            <Button
              variant="contained"
              label="Back to page"
              cssStyle="large"
              pointer="right"
              onClick={onClose}
            />
          ) : null}
          {!done && !busy ? (
            <Fragment>
              <Button
                variant="outlined"
                label="Cancel"
                cssStyle="large"
                pointer="none"
                onClick={onClose}
                className={classes.button}
              />
              <Button
                variant="contained"
                label="Confirm"
                cssStyle="large"
                pointer="none"
                onClick={deleteGroup}
                busy={busy}
                className={classes.button}
              />
            </Fragment>
          ) : null}
        </div>
      </div>
    </DialogueBase>
  );
};

DeleteGroupDialogue.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  checked: PropTypes.array.isRequired,
  setChecked: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
};

export default DeleteGroupDialogue;
